export enum PrivateProjectDocumentsParams {
  projectUuid = "projectUuid",
  projectDocumentUuid = "projectDocumentUuid",
  groupUuid = "groupUuid",
}
